import React from 'react';
import ChecklistWorkspace from './ChecklistWorkspace';
import { FeatureGate } from '../../components/common/FeatureGate';
const ChecklistsListPageWithGate: React.FC = () => {
  return (
    <FeatureGate
      requiredTiers={['pro', 'premium', 'enterprise']}
      featureName="Quality Checklists"
      featureDescription="Create and manage standardized quality checklists to ensure consistent work quality and track completion across all your projects."
      benefits={[
        'Create reusable checklist templates',
        'Track step-by-step completion',
        'Photo documentation for each step',
        'Mobile app integration for field use',
        'Quality assurance reporting',
        'Customizable for different job types',
        'Compliance and audit trail'
      ]}
    >
      <ChecklistWorkspace />
    </FeatureGate>
  );
};

export default ChecklistsListPageWithGate;